import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { Box, Button, ButtonSize, ButtonVariant, Group, GroupGutter, GroupVerticalAlign, Icon, IconColor, IconName, IconSize, Text, TextColor, TextSize, } from '@as/cotopaxi';
import { GRID_AREAS, GRID_BOX_PARAMS } from './ProductGroupPdpComparison';
import { GLOSSARY_KEY } from '../../constants/GeneralConstants';
import { isNullOrUndefined, setTooltip } from '@as-react/common-utils';
import { Divider } from '@yonderland/andes-react';
var DIVIDER_SPACING;
(function (DIVIDER_SPACING) {
    DIVIDER_SPACING[DIVIDER_SPACING["MOBILE"] = 1.5] = "MOBILE";
    DIVIDER_SPACING[DIVIDER_SPACING["DESKTOP"] = 2] = "DESKTOP";
})(DIVIDER_SPACING || (DIVIDER_SPACING = {}));
const DIVIDER_BOX_PARAMS = {
    mobile: {
        spacing: {
            marginTop: DIVIDER_SPACING.MOBILE,
            marginBottom: DIVIDER_SPACING.MOBILE,
        },
    },
    desktop: {
        spacing: {
            marginTop: DIVIDER_SPACING.DESKTOP,
            marginBottom: DIVIDER_SPACING.DESKTOP,
        },
    },
};
export const ProductGroupPdpComparisonFeatureItem = ({ name, value, productIndex, featureIndex, isGlossaryLoaded, shouldInitGlossaryTooltip, }) => {
    const [isTooltipApplied, setIsTooltipApplied] = useState(false);
    const tooltipId = `feature-item-${productIndex}-${featureIndex}`;
    const getGlossaryItem = (title, isLoaded) => { var _a; return isLoaded ? (_a = window[GLOSSARY_KEY]) === null || _a === void 0 ? void 0 : _a.find((glossary) => glossary.triggers.includes(title)) : null; };
    const glossaryItem = useMemo(() => getGlossaryItem(name, isGlossaryLoaded), [isGlossaryLoaded, shouldInitGlossaryTooltip]);
    useEffect(() => {
        if (!!glossaryItem && !isTooltipApplied) {
            setTooltip({
                element: `#${tooltipId}`,
                content: glossaryItem.description,
                title: glossaryItem.title,
                showCloseButton: false,
            });
            setIsTooltipApplied(true);
        }
    }, [glossaryItem]);
    const featureGridArea = `${GRID_AREAS.PRODUCT}-${productIndex}-${GRID_AREAS.FEATURE}-${featureIndex}`;
    let renderValue = (_jsx(Text, { size: TextSize.SMALL, lineClamp: 3, children: value }));
    if (isNullOrUndefined(value)) {
        renderValue = null;
    }
    else if (typeof value === 'boolean') {
        renderValue = value ? (_jsx(Icon, { name: IconName.CHECK, size: IconSize.MEDIUM, color: IconColor.POSITIVE })) : (_jsx(Icon, { name: IconName.MINUS, size: IconSize.MEDIUM, color: "N500" }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { gridArea: `${featureGridArea}-${GRID_AREAS.FEATURE_TITLE}` }, children: _jsxs(Box, { mobile: GRID_BOX_PARAMS.mobile, tablet: GRID_BOX_PARAMS.tablet, children: [featureIndex > 0 && (_jsx(Box, { mobile: DIVIDER_BOX_PARAMS.mobile, desktop: DIVIDER_BOX_PARAMS.desktop, children: _jsx(Divider, {}) })), _jsxs(Group, { valign: GroupVerticalAlign.CENTER, gutter: GroupGutter.NONE, children: [_jsx(Text, { color: TextColor.SUBTLE, size: TextSize.SMALL, inline: true, children: name }), glossaryItem && (_jsx(Button, { id: tooltipId, text: name, variant: ButtonVariant.TRANSPARENT_ALT, size: ButtonSize.XSMALL, icon: {
                                        name: IconName.INFORMATION_OUTLINE,
                                        color: 'N500',
                                    } }))] })] }) }), _jsx("div", { style: { gridArea: `${featureGridArea}-${GRID_AREAS.FEATURE_VALUE}` }, children: _jsx(Box, { mobile: {
                        spacing: Object.assign(Object.assign({}, GRID_BOX_PARAMS.mobile.spacing), { marginTop: 0.5 }),
                    }, tablet: GRID_BOX_PARAMS.tablet, children: renderValue }) })] }));
};
